module.exports = __webpack_public_path__ + "img/history.5de95f80.svg";